/**
 * reload / bfcache 복원 감지 (web). 완료된 주문 세션의 리로드/복원 시
 * 주문가능 세션을 부활시키지 않고 읽기전용으로 라우팅하기 위한 신호.
 * bfcache/reload 감지는 캐주얼 방지용(iOS/PWA 불완전) — URL 비주문 변경과 이중 방어.
 */
let restored = false;

/** window "pageshow" 이벤트에서 호출. persisted=true면 bfcache 복원. */
export function markPageShow(persisted: boolean): void {
    if (persisted) restored = true;
}

export function isReloadOrRestore(): boolean {
    if (restored) return true;
    try {
        const entries = (performance as any).getEntriesByType?.("navigation");
        const nav = entries && entries[0];
        if (nav) return nav.type === "reload" || nav.type === "back_forward";
        // 폴백(구형): performance.navigation.type 1=reload 2=back_forward
        const legacy = (performance as any).navigation?.type;
        return legacy === 1 || legacy === 2;
    } catch {
        return false;
    }
}

// --- LeaveGuard(beforeunload) 우회 ---
// 우리가 프로그램적으로 세션을 끝내며 문서를 떠날 때(예: IdleGuard.resetSession의 location.replace)는
// 네이티브 "이 사이트에서 나가시겠습니까?" 다이얼로그가 뜨면 안 된다(무활동 리셋이 막힘).
// resetSession이 이탈 직전 bypassNextUnload()를 호출하면, beforeunload 핸들러가 consumeBypass()로
// 1회 통과시킨다. (Chrome은 스크립트 이동엔 대개 다이얼로그를 안 띄우지만, 결정적으로 보장.)
let _bypassUnload = false;
export function bypassNextUnload(): void { _bypassUnload = true; }
export function consumeBypass(): boolean { const v = _bypassUnload; _bypassUnload = false; return v; }
